import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'sdk-token';

export const { resolve, reject } = createLifecycleFor(TYPE);
